<template>
  <div class="container-fluid wabident-clinic-main">
    <b-tabs class="clinic-main-tabs" justified lazy>
      <b-tab v-if="can_admin_treatments" index="appointments" title="Citas">
        <clinic-appointments></clinic-appointments>
      </b-tab>
      <b-tab v-if="can_admin_treatments" index="treatments" title="T. Realizados">
        <clinic-treatments></clinic-treatments>
      </b-tab>
      <b-tab v-if="can_admin_quotations" index="quotations" :title="quotations_title">
        <clinic-quotations></clinic-quotations>
      </b-tab>
      <b-tab v-if="can_admin_payments" index="payments" :title="payments_title">
        <clinic-payments></clinic-payments>
      </b-tab>
      <b-tab v-if="can_admin_payments && enable_sepa_transfers" index="bankorders" title="Remesas">
        <clinic-bank-orders></clinic-bank-orders>
      </b-tab>
      <b-tab v-if="can_admin_invoices" index="invoices" title="Facturas">
        <clinic-invoices @clinicUpdated="loadClinicData"></clinic-invoices>
      </b-tab>
      <b-tab v-if="is_admin" index="invoices-data" title="Datos Fiscales">
        <clinic-invoices-data @clinicUpdated="loadClinicData"></clinic-invoices-data>
      </b-tab>
      <b-tab v-if="is_admin && verifactu_enabled" index="verifactu-data" title="Verifactu">
        <clinic-verifactu></clinic-verifactu>
      </b-tab>
      <b-tab v-if="can_admin_invoices" index="reports-data" title="Informes">
        <clinic-reports></clinic-reports>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  props: ["clinic_id"],
  mounted() {
    this.loadClinicData();
  },
  computed: {
    enable_sepa_transfers() {
      return this.clinic && this.clinic.config.payments_enable_sepa_transfers;
    },
    is_admin() {
      return this.userCan('admin');
    },
    accounting_enabled() {
      return this.userCan('accounting')
        || this.userCan('daily_accounting')
        || this.userCan('yearly_accounting');
    },
    can_admin_treatments() {
      return this.userCan('admin-treatments') || this.accounting_enabled;
    },
    can_admin_payments() {
      return this.userCan('admin-payments') || this.accounting_enabled;
    },
    can_admin_invoices() {
      return !this.invoices_disabled && (this.userCan('admin-invoices') || this.accounting_enabled);
    },
    can_admin_quotations() {
      return this.userCan('admin-quotations') || this.accounting_enabled;
    },
    invoices_disabled() {
      if (!this.clinic) {
        return false;
      }

      return this.clinic.config.disable_invoices;
    },
    verifactu_enabled() {
      if (!this.clinic) {
        return false;
      }

      return this.clinic.config.verifactu_enabled;
    },
    reports_enabled() {
      if (!this.clinic) {
        return false;
      }

      return this.userCan('admin-invoices') && this.clinic.config.enable_reports;
    },
    quotations_title() {
      if (this.is_core) {
        return 'Planes';
      }
      return 'Presupuestos';
    },
    payments_title() {
      if (this.clinic && this.clinic.type == 'aesthetic') {
        return 'Cobros';
      }
      return 'Pagos';
    },
    ...mapGetters(["clinic", "is_core", "clinic_config"]),
  },
  methods: {
    userCan(capability) {
      if (!this.clinic) return false;
      return this.clinic.capabilities[capability] || false;
    },
    loadClinicData(clinic_id) {
      axios
        .get("/agenda/clinic_info", {
          params: {
            clinic_id: clinic_id,
          },
        })
        .then((response) => {
          let data = response.data;
          if (data.error) {
            console.log("[ERR] loadClinicData:", data.error);
          } else {
            document.title = 'Contabilidad : ' + data.name;
            this.setClinic(data);
          }
        })
        .catch((error) => {
          console.log("[ERR] loadClinicData:", error);
        });
    },
    ...mapMutations(["setClinic"]),
  },
};
</script>

<style lang="scss">
.clinic-main-tabs {
  position: relative;
  height: 53px;

  &>div:not(.tab-content) {
    background-color: var(--theme-grey-bg);
  }

  .nav-tabs {
    max-width: 1140px;
    margin: auto;

    .nav-link {
      font-size: 14px;
    }

    &::before,
    &::after {
      position: absolute;
      background-color: var(--theme-grey-bg);
      top: 0;
      left: -99em;
      width: 99em;
      height: 52px;
      display: block;
      content: "";
    }

    &::before {
      left: -99em;
    }

    &::after {
      left: 100%;
    }
  }
}
</style>
